import clientAuth from "../clientAuth";

export default {
  // get camper 
  discountType: () => clientAuth.get("discount_type/index"),

  index: () => clientAuth.get("discount/index"),
  
  store: (userData) => clientAuth.post('discount/store', { json: userData }),

  show:(id)=>clientAuth.get('discount/show/'+id),

  update:(id,userData)=>clientAuth.post(`discount/update/${id}`,{json:userData}),

  destroy:(id)=>clientAuth.delete(`discount/destroy/${id}`),
};